(() => {
  const pad = (n) => String(n).padStart(2, '0');

  function initCountdown(root) {
    const el = root.querySelector('[data-hz-countdown]');
    if (!el || el.dataset.hzReady) return;
    el.dataset.hzReady = 'true';

    const target = Number(el.dataset.target) * 1000;
    const done = root.querySelector('[data-hz-done]');
    if (!Number.isFinite(target) || target <= 0) {
      el.hidden = true;
      return;
    }

    const parts = {};
    el.querySelectorAll('[data-unit]').forEach((node) => {
      parts[node.dataset.unit] = node;
    });

    let timer = 0;
    const tick = () => {
      const left = Math.max(0, Math.floor((target - Date.now()) / 1000));
      parts.d.textContent = pad(Math.floor(left / 86400));
      parts.h.textContent = pad(Math.floor((left % 86400) / 3600));
      parts.m.textContent = pad(Math.floor((left % 3600) / 60));
      parts.s.textContent = pad(left % 60);

      if (left === 0) {
        window.clearInterval(timer);
        if (done) {
          el.hidden = true;
          done.hidden = false;
        }
      }
    };

    tick();
    timer = window.setInterval(tick, 1000);
  }

  function initDialog(root) {
    const dialog = root.querySelector('[data-hz-dialog]');
    if (!dialog || dialog.dataset.hzReady) return;
    dialog.dataset.hzReady = 'true';

    const open = () => {
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      const input = dialog.querySelector('input[type="password"]');
      if (input) input.focus();
    };
    const close = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };

    root.querySelectorAll('[data-hz-open]').forEach((button) => button.addEventListener('click', open));
    dialog.querySelectorAll('[data-hz-close]').forEach((button) => button.addEventListener('click', close));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    if (dialog.hasAttribute('data-hz-autoopen')) open();
  }

  const init = (scope) => {
    scope.querySelectorAll('[data-hz]').forEach((root) => {
      initCountdown(root);
      initDialog(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
